package org.braunequip.web.styles.AdminStyles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.css.*

val AdminTitleHeaderStyle = CssStyle {
    base {
        Modifier
            .fontSize(1.5.cssRem)
            .fontWeight(FontWeight.Bold)
            .fontFamily(FONT_FAMILY2)
    }
}

val AdminSubtitleHeaderStyle = CssStyle {
    base {
        Modifier
            .fontSize(1.25.cssRem)
            .fontFamily(FONT_FAMILY2)
            .fontWeight(FontWeight.Light)
    }
}

val AdminDescriptionStyle = CssStyle {
    base {
        Modifier
            .margin(
                topBottom = 12.px
            )
            .fontSize(1.cssRem)
            .fontFamily(FONT_FAMILY2)
            .width(50.percent)
    }
}

val AdminDetailsColumnStyle = CssStyle {
    base {
        Modifier
            .fillMaxHeight()
            .width(250.px)
    }
}

val TableHeaderStyle = CssStyle {
    base {
        Modifier
            .textAlign(TextAlign.Center)
    }
}

val TableRowHoverStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .outline(
                width = 2.px,
                style = LineStyle.Solid,
                color = Colors.Transparent
            )
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .outline(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Primary.rgb
            )
    }
}

val TableDataStyle = Modifier
//    .minHeight(40.px)
    .padding(5.px)
    .textAlign(TextAlign.Start)
    .fontSize(14.px)
    .overflow(Overflow.Hidden)
    .whiteSpace(WhiteSpace.NoWrap)
    .textOverflow(TextOverflow.Ellipsis)

val SmallColumnStyle = TableDataStyle
    .width(50.px) // Checkbox, ID

val MediumColumnStyle = TableDataStyle
    .minWidth(200.px)
    .maxWidth(200.px)

val LargeColumnStyle = TableDataStyle
    .minWidth(400.px)
    .maxWidth(400.px)
    .whiteSpace(WhiteSpace.Normal)

val ShowMoreButtonStyle = CssStyle {
    base {
        Modifier
            .margin(topBottom = 10.px)
            .textAlign(TextAlign.Center)
            .border(
                width = 1.px, LineStyle.Solid, Colors.Black
            )
            .padding(
                topBottom = 10.px,
                leftRight = 15.px
            )
            .fontFamily(FONT_FAMILY)
            .fontSize(16.px)
            .fontWeight(FontWeight.Medium)
            .cursor(Cursor.Pointer)
    }
}

val UpdateModalStyle = CssStyle {
    base {
        Modifier
            .zIndex(2)
            .position(Position.Absolute)
            .fillMaxSize()
            .backgroundColor(Theme.DarkGray.rgb)
    }
}

val LoadingCircleStyle = CssStyle {
    base {
        Modifier
    }
}

val HoverSuccessButton = CssStyle {
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Colors.Green)
            .color(Colors.White)
    }
}

val HoverWarningButton = CssStyle {
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Colors.Gold)
            .color(Colors.White)
    }
}

val HoverBadButton = CssStyle {
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Theme.Red.rgb)
            .color(Colors.White)
    }
}